import React from "react";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
// Import your utility function
import TestPrice from "../common/test-search/testPrice";
import CustomButton from "@/src/lib/ui/Button";
import Image from "next/image";

const HealthPackageCard = ({ pkg, onViewMoreClick }) => {
    const CARD_IMAGE_URL = !!pkg.cardImage
        ? `${NEXT_IMAGE_CDN}/${pkg.cardImage}`
        : `${NEXT_IMAGE_CDN}/product-cards/Blood-Group.jpg`;

    return (
        <div className="border border-solid border-gray-200 rounded-md hover:shadow-lg transition-shadow duration-300 shadow-md w-full overflow-hidden">
            <div className="relative md:h-48 h-32">
                <Image
                    src={CARD_IMAGE_URL}
                    alt={pkg.productName}
                    width={0}
                    height={0}
                    sizes="100vw"
                    className="object-cover w-full h-full"
                />
            </div>

            <div className="text-center md:p-4 p-2">
                <div>
                    <h2 className="truncate overflow-hidden whitespace-nowrap text-ellipsis max-w-60 pb-2 font-bold md:text-lg text-base text-black">
                        {pkg.productName}
                    </h2>

                    <div className="flex flex-row items-center justify-between pb-2 gap-2">
                        <div className="flex flex-row items-center">
                            {pkg?.configProductCard?.inclusions && (
                                <>
                                    <div className="flex flex-row items-center gap-1">
                                        <Iconify
                                            icon={IconCode.paramter}
                                            width="30px"
                                            color="gray"
                                        />
                                        <div className="flex flex-col items-start">
                                            {" "}
                                            {/* Use 'flex-start' for left alignment */}
                                            <p className="text-sm font-semibold text-gray-600">
                                                {
                                                    pkg?.configProductCard
                                                        ?.inclusions
                                                        .inclusionCount
                                                }{" "}
                                                {
                                                    pkg?.configProductCard
                                                        ?.inclusions
                                                        .inclusionType
                                                }
                                                {pkg?.configProductCard
                                                    ?.inclusions
                                                    .inclusionCount > 1
                                                    ? "s"
                                                    : ""}
                                            </p>
                                            <p className="text-xs text-gray-600">
                                                Included
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="flex flex-row items-center">
                            <Iconify
                                icon={IconCode.currencyNotes}
                                width="30px"
                                color="grey"
                                className="mr-1"
                            />
                            <div>
                                <p className="text-sm font-semibold text-gray-600 leading-3 pb-1">
                                    Amount
                                </p>
                                <TestPrice
                                    price={pkg?.configProductCard?.cityPrice}
                                    minPrice={pkg?.configProductCard?.minPrice}
                                    maxPrice={pkg?.configProductCard?.maxPrice}
                                    textColor={"#454F5B"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <CustomButton
                    variant="contained"
                    color="error"
                    className="w-full bg-red-600 text-white capitalize"
                    onClick={() => onViewMoreClick(pkg?.urlSlug)}
                >
                    View Details
                </CustomButton>
            </div>
        </div>
    );
};

export default HealthPackageCard;
